import { type ReactNode, useEffect, useState } from "react";
import { BottomModal } from "./BottomModal";
import { CenteredModal } from "./CenteredModal";

interface ResponsiveModalProps {
	isOpen: boolean;
	onClose: () => void;
	children: ReactNode;
}

/**
 * Responsive modal that uses CenteredModal on desktop and BottomModal on mobile
 */
export function ResponsiveModal({
	isOpen,
	onClose,
	children,
}: ResponsiveModalProps) {
	const [isDesktop, setIsDesktop] = useState(true);

	useEffect(() => {
		// Check if window is available (client-side)
		const checkIsDesktop = () => {
			setIsDesktop(window.innerWidth >= 1024);
		};

		// Initial check
		checkIsDesktop();

		// Listen for resize events
		window.addEventListener("resize", checkIsDesktop);
		return () => window.removeEventListener("resize", checkIsDesktop);
	}, []);

	if (isDesktop) {
		return (
			<CenteredModal isOpen={isOpen} onClose={onClose}>
				{children}
			</CenteredModal>
		);
	}

	return (
		<BottomModal show={isOpen} onClose={onClose}>
			<div className="flex flex-col items-center gap-6 px-6 pb-6 pt-4">
				{children}
			</div>
		</BottomModal>
	);
}
